export default function typedKeys<K extends string | number | symbol, V>(
	o: Record<K, V>,
): K[] {
	return Object.keys(o) as K[];
}
